import _ from "lodash";

export function formatFio({ name, surname, lastname }) {
  if (!name || !surname || !lastname) return false;
  return surname + " " + _.first(name) + ". " + _.first(lastname) + ".";
}
